import Vue from "vue"
import Vuex from "vuex"
import modules from "./modules"
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        "auth.token",
        "auth.user",
        "auth.subscription",
        "accounts.adAccounts",
        "accounts.adAccountId",
        "accounts.businesses",
        "accounts.businessId",
        "ads.model",
        "app.appConfig",
        "audiences.model",
      ],
    }),
  ],
  modules,
  actions: {
    clearModules(context) {
      Object.keys(this._actions).forEach(k => {
        if (k.indexOf("/clearModule") > -1) {
          context.dispatch(k)
        }
      })
    },
  },
})

import router from "@/router"

store.subscribe((mutation, state) => {
  if (mutation.type === "auth/SET_TOKEN") {
    if (!mutation.payload) {
      router.push("/login")
    }
  }
})

store.subscribeAction({
  after: action => {
    if (action.type === "auth/revokeFacebookConnection") {
      router.push("/onboard/connect/facebook")
    }
  },
})

window.store = store

export default store
